import { useContext } from 'react'

import { ChartPrintContext } from './context'

export const useChartPrint = () => useContext(ChartPrintContext)
